import { render, staticRenderFns } from "./AdminTaxReturns.vue?vue&type=template&id=4e760548&scoped=true&"
import script from "./AdminTaxReturns.vue?vue&type=script&lang=js&"
export * from "./AdminTaxReturns.vue?vue&type=script&lang=js&"
import style0 from "./AdminTaxReturns.vue?vue&type=style&index=0&id=4e760548&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e760548",
  null
  
)

export default component.exports